// extracted by mini-css-extract-plugin
export default {"generatedJoinLink":"QhEAS5bYXpM7Mo9m2TXY","finishButton":"bQfeydKAnM4YzwTbKXc8","buttonsHolder":"FaBQ2Jpbadmjuknz5EKT","buttonsHolder_2_buttons":"Dj2_kr5Ib_tbJZkiHDVC"};